import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import _ from 'lodash'
import moment from 'moment'
import {
  Modal,
  Spin,
  Button,
  Form,
  Upload,
  Icon,
  Input,
  Select,
  Tabs,
  Popconfirm,
  AutoComplete,
  message
} from 'antd'
import history from '../../../../history'
import config from '../../../../config'
import { convertToOption, convertToProposalOption, arrayMove } from '../../../../util'
import RichTextEditor from 'react-rte'

import { actions as contractActions } from '../../../../redux/modules/contractActions'
import { actions as leadContractActions } from '../../../../redux/modules/leadFunctions/leadContractActions'

import ContractPaymentSchedules from './ContractPaymentSchedules'

import * as authSelectors from '../../../../selectors/auth'
import * as revisionSelectors from '../../../../selectors/revision'
import * as proposalsSelectors from '../../../../selectors/lead/proposals'
import * as contractsSelectors from '../../../../selectors/lead/contracts'

const { API_BASE } = config
const FormItem = Form.Item
const { TextArea } = Input
const ButtonGroup = Button.Group
const Option = Select.Option
const TabPane = Tabs.TabPane

const propTypes = {
  // from container
  action: PropTypes.string.isRequired,
  contentData: PropTypes.object,
  contractId: PropTypes.any,
  handleSetContentData: PropTypes.func.isRequired,

  contracts: PropTypes.array,
  loadingRevision: PropTypes.bool,
  revisions: PropTypes.array,
  proposals: PropTypes.array,
  contractsTemplates: PropTypes.array,
  contractPaymentScheduleTemplate: PropTypes.any,
  contractPaymentSchedules: PropTypes.any,
  user: PropTypes.object,
  uploadingAttachment: PropTypes.bool,

  // actions
  getContractPaymentScheduleTemplate: PropTypes.func.isRequired,
  createLeadContract: PropTypes.func.isRequired,
  updateLeadContract: PropTypes.func.isRequired,
  uploadAttachment: PropTypes.func.isRequired,
  setContractStatus: PropTypes.func.isRequired
}

class AddEditFormModal extends Component {
  state = {
    currentRevisionNumberPrint: 1,
    activePane: '1',
    paymentScheduleDataStructure: [],
    overview: RichTextEditor.createEmptyValue(),
    work_by_others: RichTextEditor.createEmptyValue(),
    terms: RichTextEditor.createEmptyValue(),
    header: RichTextEditor.createEmptyValue(),
    footer: RichTextEditor.createEmptyValue(),
    updatedNow: false
  }

  componentDidUpdate(prevProps) {
    const {
      loadingRevision,
      revisions,
      contractPaymentScheduleTemplate,
      contractPaymentSchedules,
      contracts,
      uploadingAttachment,
      contractId,
      handleSetContentData,
      contentData
    } = this.props
    const {
      loadingRevision: prevLoadingRevision,
      contractPaymentScheduleTemplate: prevContractPaymentScheduleTemplate,
      contractPaymentSchedules: prevContractPaymentSchedules,
      contracts: prevContracts
    } = prevProps

    // check from where charge the paymentSchedule information
    if (contractPaymentScheduleTemplate !== prevContractPaymentScheduleTemplate) {
      this.loadPaymentScheduleData('template')
    }
    if (contractPaymentSchedules !== prevContractPaymentSchedules) {
      this.loadPaymentScheduleData('existent')
    }

    // update the current version for printing
    if (prevLoadingRevision !== loadingRevision) {
      if (revisions) {
        this.setState({
          currentRevisionNumberPrint: revisions[revisions.length - 1].currentRevisionNumber
        })
      }
    }

    // update replaced/added file on signed contract
    const currentContract = _.find(contracts, contract => contract.id === parseInt(contractId, 10))
    const prevContract = _.find(prevContracts, contract => contract.id === parseInt(contractId, 10))

    if (currentContract && currentContract.signedContract) {
      if (
        !prevContract.signedContract ||
        currentContract.signedContract.filename !== prevContract.signedContract.filename
      ) {
        if (!uploadingAttachment) {
          let contentDataNew = { ...contentData }
          const currentContract = _.find(
            contracts,
            contract => contract.id === parseInt(contractId, 10)
          )
          contentDataNew.signedContract = { ...currentContract.signedContract }
          handleSetContentData(contentDataNew)
        }
      }
    }
  }

  loadPaymentScheduleData = source => {
    const { contractPaymentScheduleTemplate, contractPaymentSchedules } = this.props
    let paymentSchedule = []
    if (source === 'template') {
      paymentSchedule = contractPaymentScheduleTemplate
    } else {
      paymentSchedule = contractPaymentSchedules
    }

    this.setState({
      paymentScheduleDataStructure: paymentSchedule
    })
  }

  handleCancel = () => {
    const { form, leadId } = this.props
    form.resetFields()
    history.push(`/lead/${leadId}/contracts`)
  }

  handleProposalChange = proposalId => {
    const { form, proposals } = this.props
    const selectedProposal = proposals.find(proposal => parseInt(proposalId, 10) === proposal.id)
    if (selectedProposal) {
      form.setFieldsValue({
        overview: RichTextEditor.createValueFromString(selectedProposal.overview, 'html')
      })
    }
  }

  handleTemplateChange = event => {
    const { form, contractsTemplates, getContractPaymentScheduleTemplate } = this.props
    const selectedTemplate = contractsTemplates.filter(
      row => parseInt(row.id, 0) === parseInt(event, 0)
    )
    if (selectedTemplate.length > 0) {
      this.setState({
        name: selectedTemplate[0].name
      })

      // get payment schedules
      getContractPaymentScheduleTemplate({ templateId: selectedTemplate[0].id })

      form.setFieldsValue({
        work_by_others: RichTextEditor.createValueFromString(
          selectedTemplate[0].work_by_others,
          'html'
        ),
        terms: RichTextEditor.createValueFromString(selectedTemplate[0].terms, 'html'),
        header: RichTextEditor.createValueFromString(selectedTemplate[0].header, 'html'),
        footer: RichTextEditor.createValueFromString(selectedTemplate[0].footer, 'html'),
        description: selectedTemplate[0].description
      })
    }
  }

  handleCreate = () => {
    const {
      form,
      leadId,
      createLeadContract,
      user,
      action,
      updateLeadContract,
      contractId
    } = this.props
    const { paymentScheduleDataStructure, proposalId, name } = this.state
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      values.overview = values.overview.toString('html')
      values.work_by_others = values.work_by_others.toString('html')
      values.terms = values.terms.toString('html')
      values.header = values.header.toString('html')
      values.footer = values.footer.toString('html')
      values.proposal_id = proposalId
      values.name = name

      if (action === 'add') {
        createLeadContract({
          leadId: leadId,
          content: values,
          userId: user.userId,
          paymentSchedule: paymentScheduleDataStructure
        })
        message.success('Contract Created')
      } else {
        updateLeadContract({
          leadId: leadId,
          contractId: contractId,
          content: values,
          userId: user.userId,
          paymentSchedule: paymentScheduleDataStructure
        })
        message.success('Changes saved.')
      }

      form.resetFields()
      this.setState({
        paymentScheduleDataStructure: [],
        activePane: '1'
      })
      history.push(`/lead/${leadId}/contracts`)
    })
  }

  handleIProposalItemSelect = proposal => {
    this.setState({
      proposalId: proposal
    })
  }

  handleRevisionChange = revisionNumber => {
    const { form, revisions } = this.props
    const htmlFields = ['terms', 'overview', 'work_by_others', 'header', 'footer']

    const revision = revisions[revisionNumber]

    // set revision for printing
    this.setState({
      currentRevisionNumberPrint: revision.currentRevisionNumber
    })

    let changes = {}
    _.forEach(revision, (fieldValue, fieldName) => {
      if (!_.isNil(form.getFieldsValue()[fieldName])) {
        if (htmlFields.includes(fieldName)) {
          changes[fieldName] = RichTextEditor.createValueFromString(fieldValue.toString(), 'html')
        } else {
          changes[fieldName] = fieldValue.toString()
        }
      }

      if (fieldName === 'paymentSchedule') {
        this.setState({
          paymentScheduleDataStructure: fieldValue
        })
      }
    })

    changes.status = changes.status ? changes.status : 'Created'
    form.setFieldsValue(changes)
  }

  /* Schedules actions */
  handleAddPaymentSchedule = () => {
    const newPaymentSchedule = this.state.paymentScheduleDataStructure
    newPaymentSchedule.push({
      percentage: 0,
      description: ''
    })
    this.setState({
      paymentScheduleDataStructure: newPaymentSchedule
    })
  }

  handlePaymentScheduleChange = (value, field, index) => {
    let newPaymentSchedulesDataStructure = this.state.paymentScheduleDataStructure
    if (field === 'description') {
      newPaymentSchedulesDataStructure[index].description = value
    } else {
      newPaymentSchedulesDataStructure[index].percentage = value / 100
    }
    this.setState({
      paymentScheduleDataStructure: newPaymentSchedulesDataStructure
    })
  }

  movePaymentScheduleUp = index => {
    const newPaymentSchedulesDataStructure = arrayMove(
      this.state.paymentScheduleDataStructure,
      index,
      index - 1
    )
    this.setState({
      paymentScheduleDataStructure: newPaymentSchedulesDataStructure
    })
  }

  movePaymentScheduleDown = index => {
    const newPaymentSchedulesDataStructure = arrayMove(
      this.state.paymentScheduleDataStructure,
      index,
      index + 1
    )
    this.setState({
      paymentScheduleDataStructure: newPaymentSchedulesDataStructure
    })
  }

  handleDeletePaymentSchedule = index => {
    const { paymentScheduleDataStructure } = this.state
    let tmpPaymentSchedulesDataStructure = paymentScheduleDataStructure
    tmpPaymentSchedulesDataStructure.splice(index, 1)
    this.setState({
      paymentScheduleDataStructure: tmpPaymentSchedulesDataStructure
    })
  }

  confirmDelete = event => {
    const { leadId, form, contractId, deleteLeadContract } = this.props

    deleteLeadContract({
      leadId: leadId,
      contractId: contractId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState(
      {
        activePane: '1'
      },
      () => {
        history.push(`/lead/${leadId}/contracts`)
      }
    )
  }

  getUpdatedDate = () => {
    const { contentData } = this.props
    const { updatedNow } = this.state
    return moment(updatedNow ? updatedNow : contentData.updated_date).format('M/D/YYYY')
  }

  handleUploadAttachment = uploadParam => {
    const formData = new FormData()

    const { user, leadId, uploadAttachment, contractId } = this.props

    formData.append('file', uploadParam.file)
    formData.append('type', 'contract')
    formData.append('created_by_id', user.userId)
    formData.append('updated_by_id', user.userId)
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('currentId', contractId)

    uploadAttachment({
      formData: formData,
      contractId: contractId,
      leadId: leadId
    })
    this.setState({
      updatedNow: new Date()
    })
  }

  handleSetContractStatus = status => {
    const { leadId, setContractStatus, contractId } = this.props
    setContractStatus({
      status: status,
      contractId: contractId,
      leadId: leadId
    })

    history.push(`/lead/${leadId}/contracts`)
  }

  render() {
    const {
      action,
      contentData,
      loadingRevision,
      revisions,
      proposals,
      contractsTemplates
    } = this.props
    const { currentRevisionNumberPrint } = this.state
    const { getFieldDecorator } = this.props.form
    return (
      <div>
        <Modal
          visible={true}
          title="Contracts"
          okText={action === 'add' ? 'Create' : 'Save Changes'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          width="90%"
          maskClosable={false}
        >
          {contentData && (
            <div className="row">
              <div className="col-10">
                <h2 className="marginBottom0">Contract #{this.state.currentId}</h2>
              </div>
              <div className="col-2 text-right">
                {loadingRevision ? (
                  <Spin size="small" />
                ) : (
                  <a
                    href={`${API_BASE}/api/lead/contracts/${contentData.id}/print?revision=${
                      currentRevisionNumberPrint
                    }`}
                    target="_blank"
                  >
                    <Button icon="printer">Print Contract</Button>
                  </a>
                )}
              </div>
            </div>
          )}
          <Form layout="vertical">
            {contentData && (
              <div className="row">
                <div className="col-md-6">
                  <div className="row mt-2">
                    <div className="col-12">
                      Created By:{' '}
                      <strong>{`${contentData.created_by_first_name} ${
                        contentData.created_by_last_name
                      }`}</strong>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-6">
                      Created Date:{' '}
                      <strong>{moment(contentData.created_date).format('M/D/YYYY')}</strong>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-6">
                      Updated By:{' '}
                      <strong>{`${contentData.updated_by_first_name} ${
                        contentData.updated_by_last_name
                      }`}</strong>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-6">
                      Updated Date: <strong>{this.getUpdatedDate()}</strong>
                    </div>
                  </div>
                  {_.get(contentData, 'signedContract.filename') && (
                    <div className="row mt-2">
                      <div className="col-6">
                        Signed Contract:<br />
                        <strong>
                          <a
                            href={_.get(contentData, 'signedContract.signedUrl')}
                            title={_.get(contentData, 'signedContract.filename')}
                            target="_blank"
                          >
                            {_.get(contentData, 'signedContract.filename')}
                          </a>
                        </strong>
                      </div>
                    </div>
                  )}
                  <div className="row mt-2">
                    <div className="col-6">
                      <Upload
                        name="file"
                        customRequest={this.handleUploadAttachment}
                        showUploadList={false}
                      >
                        <Button>
                          <Icon type="upload" /> Upload Signed Contract
                        </Button>
                      </Upload>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 text-right">
                  {contentData && (
                    <FormItem label="Mark As:">
                      <ButtonGroup>
                        <Popconfirm
                          title="Are you sure you want to change the Proposal Status?"
                          onConfirm={() => this.handleSetContractStatus('sent')}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button disabled={contentData.status === 'sent'}>Sent</Button>
                        </Popconfirm>

                        <Popconfirm
                          title="Are you sure you want to change the Proposal Status?"
                          onConfirm={() => this.handleSetContractStatus('received')}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button disabled={contentData.status === 'received'}>Received</Button>
                        </Popconfirm>
                        <Popconfirm
                          title="Are you sure you want to change the Proposal Status?"
                          onConfirm={() => this.handleSetContractStatus('signed')}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button disabled={contentData.status === 'signed'}>Signed</Button>
                        </Popconfirm>
                      </ButtonGroup>
                    </FormItem>
                  )}

                  <FormItem label="Revision">
                    {loadingRevision ? (
                      <Spin size="small" />
                    ) : (
                      <Select
                        defaultValue={
                          revisions ? revisions[revisions.length - 1].currentRevisionNumber : null
                        }
                        onChange={this.handleRevisionChange}
                      >
                        {revisions &&
                          revisions.map(revision => (
                            <Option
                              key={revision.currentRevisionNumber}
                              value={revision.currentRevisionNumber - 1} // revision index
                            >
                              {revision.currentRevisionNumber}
                            </Option>
                          ))}
                      </Select>
                    )}
                  </FormItem>
                </div>
              </div>
            )}
            <Tabs defaultActiveKey={this.state.activePane}>
              <TabPane tab="Details" key="1">
                <FormItem label="Proposal">
                  {getFieldDecorator('proposal_id', {
                    rules: [
                      {
                        required: true,
                        message: 'You must choose a Proposal.'
                      }
                    ],
                    initialValue: contentData
                      ? `${contentData.proposal_id} - ${contentData.proposal_description}`
                      : null
                  })(
                    <AutoComplete
                      dataSource={convertToProposalOption(proposals)}
                      onSelect={this.handleIProposalItemSelect}
                      filterOption={(inputValue, option) =>
                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      }
                      onChange={this.handleProposalChange}
                    >
                      <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                    </AutoComplete>
                  )}
                </FormItem>
                <FormItem label="Template">
                  {getFieldDecorator('contract_template_id', {
                    initialValue: contentData ? contentData.contract_template_name : null
                  })(
                    <AutoComplete
                      dataSource={convertToOption(contractsTemplates)}
                      onSelect={this.handleItemSelect}
                      filterOption={(inputValue, option) =>
                        option.props.children &&
                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      }
                      onChange={this.handleTemplateChange}
                    >
                      <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                    </AutoComplete>
                  )}
                </FormItem>

                <FormItem label="Description">
                  {getFieldDecorator('description', {
                    rules: [
                      {
                        required: true,
                        message: 'Contract description cannot be blank.'
                      }
                    ],
                    initialValue: contentData ? contentData.description : ''
                  })(
                    <TextArea
                      placeholder="Describe the attachment..."
                      rows={4}
                      initialvalue={contentData ? contentData.description : ''}
                    />
                  )}
                </FormItem>

                <FormItem label="Overview">
                  {getFieldDecorator('overview', {
                    initialValue:
                      contentData && contentData.terms
                        ? RichTextEditor.createValueFromString(contentData.overview, 'html')
                        : RichTextEditor.createValueFromString('', 'html')
                  })(<RichTextEditor />)}
                </FormItem>

                <FormItem label="Work By Others">
                  {getFieldDecorator('work_by_others', {
                    initialValue:
                      contentData && contentData.work_by_others
                        ? RichTextEditor.createValueFromString(contentData.work_by_others, 'html')
                        : RichTextEditor.createValueFromString('', 'html')
                  })(<RichTextEditor />)}
                </FormItem>

                <FormItem label="Terms">
                  {getFieldDecorator('terms', {
                    initialValue:
                      contentData && contentData.terms
                        ? RichTextEditor.createValueFromString(contentData.terms, 'html')
                        : RichTextEditor.createValueFromString('', 'html')
                  })(<RichTextEditor />)}
                </FormItem>

                <FormItem label="Header">
                  {getFieldDecorator('header', {
                    initialValue:
                      contentData && contentData.header
                        ? RichTextEditor.createValueFromString(contentData.header, 'html')
                        : RichTextEditor.createValueFromString('', 'html')
                  })(<RichTextEditor />)}
                </FormItem>

                <FormItem label="Footer">
                  {getFieldDecorator('footer', {
                    initialValue:
                      contentData && contentData.header
                        ? RichTextEditor.createValueFromString(contentData.footer, 'html')
                        : RichTextEditor.createValueFromString('', 'html')
                  })(<RichTextEditor />)}
                </FormItem>
              </TabPane>
              <TabPane tab="Schedules" key="2">
                <ContractPaymentSchedules
                  paymentScheduleDataStructure={this.state.paymentScheduleDataStructure}
                  handleDeletePaymentSchedule={this.handleDeletePaymentSchedule}
                  handlePaymentScheduleChange={this.handlePaymentScheduleChange}
                  movePaymentScheduleUp={this.movePaymentScheduleUp}
                  movePaymentScheduleDown={this.movePaymentScheduleDown}
                  handleAddPaymentSchedule={this.handleAddPaymentSchedule}
                />
              </TabPane>
            </Tabs>

            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {contentData && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Form>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  contracts: contractsSelectors.getContracts(state, props),
  loadingRevision: revisionSelectors.getRevisionsLoading(state, props),
  revisions: revisionSelectors.getRevisions(state, props),
  proposals: proposalsSelectors.getProposals(state, props),
  contractsTemplates: contractsSelectors.getContractsTemplates(state, props),
  contractPaymentScheduleTemplate: contractsSelectors.getContractPaymentScheduleTemplate(
    state,
    props
  ),
  contractPaymentSchedules: contractsSelectors.getContractPaymentSchedules(state, props),
  user: authSelectors.getUser(state, props),
  uploadingAttachment: contractsSelectors.getUploadingAttachment(state, props)
})

const mapDispatchToProps = (dispatch, props) => ({
  getContractPaymentScheduleTemplate: ({ templateId }) =>
    dispatch(contractActions.getContractPaymentScheduleTemplate({ templateId })),
  createLeadContract: ({ leadId, content, userId, paymentSchedule }) =>
    dispatch(
      leadContractActions.createLeadContract({
        leadId,
        content,
        userId,
        paymentSchedule
      })
    ),
  updateLeadContract: ({ leadId, contractId, content, userId, paymentSchedule }) =>
    dispatch(
      leadContractActions.updateLeadContract({
        leadId,
        contractId,
        content,
        userId,
        paymentSchedule
      })
    ),
  deleteLeadContract: ({ leadId, contractId }) =>
    dispatch(
      leadContractActions.deleteLeadContract({
        leadId,
        contractId
      })
    ),
  uploadAttachment: ({ formData, contractId, leadId }) =>
    dispatch(
      leadContractActions.uploadAttachment({
        formData,
        contractId,
        leadId
      })
    ),

  setContractStatus: ({ status, contractId, leadId }) =>
    dispatch(
      leadContractActions.setContractStatus({
        status,
        contractId,
        leadId
      })
    )
})

AddEditFormModal.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(AddEditFormModal))
)



// WEBPACK FOOTER //
// ./src/pages/lead/components/contracts/AddEditFormModal.component.js